import React from 'react'
import styled from 'styled-components'

const Svg = styled.svg`
  path {
    transition: all 800ms;
  }
`

export default ({ color1, color2 }) => (
  <Svg width="61" height="62" viewBox="0 0 61 62" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
        <path d="M8.286 15c-1.72 0-3.44-.655-4.75-1.964L3 12.5l1.072-1.073.537.537a5.207 5.207 0 0 0 7.355 0 5.208 5.208 0 0 0 0-7.355l-.536-.536L12.499 3l.537.536a6.725 6.725 0 0 1 0 9.5A6.697 6.697 0 0 1 8.286 15"
        fill={color1 || '#fff'} />
        <path d="M8.164 19a10.764 10.764 0 0 1-7.662-3.174L0 15.324l1.004-1.005.503.503a9.354 9.354 0 0 0 6.657 2.757c2.515 0 4.879-.98 6.657-2.757a9.35 9.35 0 0 0 2.758-6.658c0-2.515-.979-4.88-2.758-6.657l-.502-.502L15.324 0l.502.502A10.764 10.764 0 0 1 19 8.164c0 2.895-1.127 5.616-3.174 7.662A10.763 10.763 0 0 1 8.164 19M23 43h.974V20H23zM39 43h.974V20H39zM32 22h.974V7H32zM29 20h.974v-7H29zM35 20h.974v-7H35z"
        fill={color1 || '#fff'} />
        <path fill={color1 || '#fff'} d="M32.5 48L24 43.329 24.645 42l7.855 4.317L40.355 42 41 43.329zM32.5 42L24 37.328 24.645 36l7.855 4.317L40.355 36 41 37.328zM32.5 36L24 31.329 24.645 30l7.855 4.317L40.355 30 41 31.329zM32.5 28L24 23.329 24.645 22l7.855 4.317L40.355 22 41 23.329z"
        />
        <path fill={color1 || '#fff'} d="M32 57h.974V26H32z" />
        <path fill={color2 || '#fff'} d="M61 41h-7.584v1.438h5.677l-5.288 18.124H11.199L5.924 43.014h5.317v-1.439H4L10.14 62h44.732z"
        />
    </g>
</Svg>
);


// WEBPACK FOOTER //
// ./src/ui/components/generic/IconCapacitive.js